const leftSideMenuData = [
  {
    id: 1,
    icon: <i className="icon-dashboard"></i>,
    path: "/",
    name: "Dashboard",
    url: "/",
  },
  {
    id: 2,
    icon: <i className="icon-transaction"></i>,
    path: "transactions",
    name: "Transactions",
    url: "/transactions",
  },
  {
    id: 3,
    icon: <i className="icon-pay"></i>,
    path: "pay",
    name: "Pay",
    url: "/pay",
    hidden: true,
  },
  {
    id: 4,
    icon: <i className="icon-receive"></i>,
    path: "receive",
    name: "Receive",
    url: "/receive",
  },
  {
    id: 5,
    icon: <i className="icon-exchange"></i>,
    path: "exchange",
    name: "Exchange",
    url: "/exchange/step-1",
  },
  {
    id: 6,
    icon: <i className="icon-recipients"></i>,
    path: "recipients",
    name: "Recipients",
    url: "/recipients",
    hidden: true,
  },
  {
    id: 7,
    icon: <i className="icon-crypto"></i>,
    path: "crypto",
    name: "Crypto",
    url: "/crypto",
    hidden: true,
  },
  {
    id: 8,
    icon: <i className="icon-deposit"></i>,
    path: "deposit-money",
    name: "Deposit Money",
    url: "/deposit-money/step-1",
    hidden: true,
  },
  {
    id: 9,
    icon: <i className="icon-withdraw"></i>,
    path: "withdraw-money",
    name: "Withdraw Money",
    url: "/withdraw-money/step-1",
    hidden: true,
  },
];

export default leftSideMenuData;
